var React = require('react');

function ArrowCta (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#f5f4f2;}")),React.createElement("path",{"className":"a","d":"M11243.572,10281.676l3.86,3.86-3.86,3.86","transform":"translate(-11243.219 -10281.322)","key":1})]);
}

ArrowCta.defaultProps = {"width":"4.921","height":"8.428","viewBox":"0 0 4.921 8.428"};

module.exports = ArrowCta;

ArrowCta.default = ArrowCta;
